import React, { useEffect, useState, } from "react"
import { mapClient, } from "globalInstance"
import FloorSelector, { Floor, } from "feature/FloorSelector"
import { MapLocation, MapPosition, MapSetupOption, } from "indoor-map-lib"
import { ConnectedProps, connect, useSelector, } from "react-redux"
import { selectState, slice, } from "app/App/redux"
import style from "./style.module.scss"

// はじめのズームサイズ(直径 * 割合)
const defaultZoomSize = 11722 * 0.4

const mapDispatch = { ...slice.actions, }
const connector = connect(null, mapDispatch)
type Props = ConnectedProps<typeof connector>

/**
 * Mappedinでマップを表示するコンポーネントです
 */
function MapView ({
  initialize,
  setCurrentLocation,
  setCurrentLevel,
  setHasUserPosition,
}: Props) {
  const {
    initialized,
    currentLevel,
    forceEnableBlueDot,
  } = useSelector(selectState)

  const [currentFloor, setCurrentFloor] = useState<Floor | null>(null)

  useEffect(() => {
    if (initialized) {
      const floor: Floor = {
        level: currentLevel,
        label: mapClient.getFloorLabel(currentLevel),
      }
      setCurrentFloor(floor)
    }
  }, [initialized, currentLevel])

  useEffect(() => {
    if (!initialized) {
      const element = document.getElementById("mapView")
      if (!element) {
        throw Error("element is not found.")
      }

      const option: MapSetupOption = {}
      // 現在 BlueDot は階段などでうまく表示されないためどの端末でも表示をしない
      // debug 時のフラグを立てたときだけ有効化される
      option.enableBlueDot = forceEnableBlueDot || false

      // divを渡してMappedinを初期化してコールバックを設定します
      mapClient.initialize(element, option).then(() => {
        mapClient.setOnLocationClick(onLocationClick)
        mapClient.setOnChangeUserPosition((position: MapPosition | null) => {
          setHasUserPosition(position !== null)
        })
        mapClient.setOnChangeLevel((level: number) => {
          setCurrentLevel(level)
        })

        // マップのロード完了後のコールバック
        mapClient.setOnFirstMapLoaded(() => {
          // マップの拡大率を設定する
          mapClient.setZoom(defaultZoomSize)

          // カメラの位置をマップ上のコートが中心になるように調整します
          const pos = mapClient.getPosition()
          mapClient.setPosition(pos.x - 275, pos.y)

          initialize()
        })
      })
    }
  }, [])

  /**
   * ロケーション選択時の処理
   * @param location
   */
  const onLocationClick = (location: MapLocation) => {
    setCurrentLocation(location.id)
  }

  /**
   * フロア変更時の処理
   * @param newFloor
   */
  const onFloorChange = (newFloor: Floor) => {
    setCurrentLevel(newFloor.level)
  }

  return (
    <div className={style.mapContainer}>
      <div
        id="mapView"
        style={{
          opacity: initialized ? 1 : 0,
        }}
        className={style.mapview}
      ></div>
      {(initialized && currentFloor) && (
        <FloorSelector
          currentFloor={currentFloor}
          onChange={onFloorChange} />
      )}
    </div>
  )
}

export default connector(MapView)
